// Pátria CRM: datas em português no sistema todo. O vite.config.ts aponta "date-fns" para este arquivo:
// ele repassa tudo da biblioteca original, mas o format (e as distâncias, "há 5 minutos") usam o
// idioma pt-BR e os formatos americanos que o núcleo usa viram o formato brasileiro
// ("Oct 18, 2026" → "18 de out. de 2026", "4:42 PM" → "16:42", "18-Oct" → "18/10").
import * as dateFns from 'date-fns/esm/index.js';
import ptBR from 'date-fns/esm/locale/pt-BR/index.js';

export * from 'date-fns/esm/index.js';

export const PATTERNS = {
  'MMM d, yyyy': "d 'de' MMM 'de' yyyy",
  'MMM dd, yyyy': "dd 'de' MMM 'de' yyyy",
  'MMM d': "d 'de' MMM",
  'dd-MMM': 'dd/MM',
  'MMM-yyyy': 'MMM/yyyy',
  'dd MMM, yyyy': "dd 'de' MMM 'de' yyyy",
  'LLL d, yyyy': "d 'de' LLL 'de' yyyy",
  'LLL d, h:mm a': "d 'de' LLL, HH:mm",
  'LLL d yyyy, h:mm a': "d 'de' LLL 'de' yyyy, HH:mm",
  'LLL d y, h:mm a': "d 'de' LLL 'de' y, HH:mm",
  'LLL d, yyyy hh:mm a': "d 'de' LLL 'de' yyyy, HH:mm",
  'MMM dd, yyyy, hh:mm a': "dd 'de' MMM 'de' yyyy, HH:mm",
  "EEE, MMM d, yyyy 'at' p": "EEE, d 'de' MMM 'de' yyyy 'às' HH:mm",
  'EEE, d MMM, h:mm a': "EEE, d 'de' MMM, HH:mm",
  'EEE, d MMM yyyy, h:mm a': "EEE, d 'de' MMM 'de' yyyy, HH:mm",
  'd MMM, h.mmaaa': "d 'de' MMM, HH:mm",
  'd MMM yyyy, h.mmaaa': "d 'de' MMM 'de' yyyy, HH:mm",
  'h.mmaaa': 'HH:mm',
  'h:mm a': 'HH:mm',
  'hh:mm a': 'HH:mm',
};

const withLocale = options => ({ locale: ptBR, ...options });

export function format(date, pattern, options) {
  return dateFns.format(
    date,
    PATTERNS[pattern] || pattern,
    withLocale(options)
  );
}

export function formatDistance(date, baseDate, options) {
  return dateFns.formatDistance(date, baseDate, withLocale(options));
}

export function formatDistanceStrict(date, baseDate, options) {
  return dateFns.formatDistanceStrict(date, baseDate, withLocale(options));
}

export function formatDistanceToNow(date, options) {
  return dateFns.formatDistanceToNow(date, withLocale(options));
}

export function formatDistanceToNowStrict(date, options) {
  return dateFns.formatDistanceToNowStrict(date, withLocale(options));
}

export function formatRelative(date, baseDate, options) {
  return dateFns.formatRelative(date, baseDate, withLocale(options));
}
